import axios from "axios";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";

export const obtenerCotizacion = ({dimencionesTotal, pesoTotal, codigoDane, bodega, valorTotal, direccionEnvio}) => {


    // console.log(total)

    let data = JSON.stringify(
        {
            "packages": [
                {
                    "weight": pesoTotal,
                    "height": dimencionesTotal.alto,
                    "width": dimencionesTotal.ancho,
                    "length": dimencionesTotal.fondo
                }
            ],
            "description": "Pedido Amevi",
            "contentValue": valorTotal,
            "codValue": valorTotal,
            "includeGuideCost": false,
            "codPaymentMethod": "cash",
            "origin": {
                "daneCode": bodega.codigo,
                "address": bodega.direccion
            },
            "destination": {
                "daneCode": codigoDane + '000',
                "address": direccionEnvio
            }
        });

    let config = {
        method: 'post',
        url: 'https://api.envioclickpro.com.co/api/v2/quotation',
        headers: {
            'Authorization': 'd579cb35-81f8-4590-8d71-19cb90221223',
            'Content-Type': 'application/json'
        },
        data: data
    };

    return new Promise((resolve) => {
        axios(config)
            .then(function (response) {
                //console.log(response.data)
                if (response.status === 200) {
                    return resolve({res: true, data: response.data.data.rates})
                } else {
                    return resolve({res: false, data: "error interno"})
                }

            })
            .catch(function (error) {
                //console.log(error)
                let obj = {
                    nombre: "Generando Guia",
                    fecha: new Date().getTime(),
                    datos: JSON.stringify(error)
                }
                guardarDoc('errores', obj).then()
                return resolve({res: false, data: error.message})

            });

    })


}